// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  font-family: Roboto;
}

.Info_heading {
  color: #fff;
  text-align: center;
  font-size: 5.1vh;
  font-style: normal;
  font-weight: 700;
  line-height: 100%;
  margin-top: 8vw;
}
@media (max-width: 768px) {
  .Info_heading {
    font-size: 4vw;
  }
}
@media (max-width: 576px) {
  .Info_heading {
    font-size: 5vw;
    margin-left: 2vw;
    margin-right: 2vw;
  }
}
.Info_para {
  color: #fff;
  margin-top: 2vw;
  text-align: center;
  padding-left: 10.5vw;
  padding-right: 10.5vw;
  font-size: 1.6vw;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}
@media (min-width: 2560px) {
  .Info_para {
    font-size: 1.6vw;
  }
}
@media (max-width: 992px) {
  .Info_para {
    font-size: 3.5vw;
  }
}
@media (max-width: 768px) {
  .Info_para {
    font-size: 2.5vw;
  }
}
@media (max-width: 576px) {
  .Info_para {
    font-size: 3.5vw;
    padding-left: 5.5vw;
    padding-right: 5.5vw;
  }
}
.Info_para1 {
  color: #fff;
  margin-top: 0.5vw;
  text-align: center;
  padding-left: 10.5vw;
  padding-right: 10.5vw;
  font-size: 1.6vw;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}
@media (max-width: 992px) {
  .Info_para1 {
    font-size: 2vw;
  }
}
@media (max-width: 768px) {
  .Info_para1 {
    font-size: 2vw;
  }
}
@media (max-width: 576px) {
  .Info_para1 {
    font-size: 3.5vw;
    padding-left: 5.5vw;
    padding-right: 5.5vw;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/InfoBankingServices/info.scss"],"names":[],"mappings":"AAAA;EAEE,mBAAA;AAAF;;AAGE;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AAAJ;AACI;EARF;IASI,cAAA;EAEJ;AACF;AADI;EAXF;IAYI,cAAA;IACA,gBAAA;IACF,iBAAA;EAIF;AACF;AAFE;EACE,WAAA;EACA,eAAA;EACA,kBAAA;EACA,oBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAIJ;AAHI;EAVF;IAWI,gBAAA;EAMJ;AACF;AALI;EAbF;IAcI,gBAAA;EAQJ;AACF;AAPI;EAhBF;IAiBI,gBAAA;EAUJ;AACF;AATI;EAnBF;IAoBI,gBAAA;IACA,mBAAA;IACA,oBAAA;EAYJ;AACF;AATE;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAWJ;AAVI;EAVF;IAWI,cAAA;EAaJ;AACF;AAZI;EAbF;IAcI,cAAA;EAeJ;AACF;AAdI;EAhBF;IAiBI,gBAAA;IACA,mBAAA;IACA,oBAAA;EAiBJ;AACF","sourcesContent":["* {\n \n  font-family: Roboto;\n}\n.Info {\n  &_heading {\n    color: #fff;\n    text-align: center;\n    font-size: 5.1vh;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 100%;\n    margin-top: 8vw;\n    @media (max-width: 768px) {\n      font-size: 4vw;\n    }\n    @media (max-width: 576px) {\n      font-size: 5vw;\n      margin-left: 2vw;\n    margin-right: 2vw;\n    }\n  }\n  &_para {\n    color: #fff;\n    margin-top: 2vw;\n    text-align: center;\n    padding-left: 10.5vw;\n    padding-right: 10.5vw;\n    font-size: 1.6vw;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 150%;\n    @media (min-width: 2560px) {\n      font-size: 1.6vw;\n    }\n    @media (max-width: 992px) {\n      font-size: 3.5vw;\n    }\n    @media (max-width: 768px) {\n      font-size: 2.5vw;\n    }\n    @media (max-width: 576px) {\n      font-size: 3.5vw;\n      padding-left: 5.5vw;\n      padding-right: 5.5vw;\n    }\n\n  }\n  &_para1 {\n    color: #fff;\n    margin-top: .5vw;\n    text-align: center;\n    padding-left: 10.5vw;\n    padding-right: 10.5vw;\n    font-size: 1.6vw;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 150%;\n    @media (max-width: 992px) {\n      font-size: 2vw;\n    }\n    @media (max-width: 768px) {\n      font-size: 2vw;\n    }\n    @media (max-width: 576px) {\n      font-size: 3.5vw;\n      padding-left: 5.5vw;\n      padding-right: 5.5vw;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
